import styled from "styled-components";
import { keyframes } from "styled-components";

const showInfo = keyframes`
  0% {
    transform: translateX(70%);
    opacity: 0;
  }
  80% {
    transform: translateX(95%);
    opacity: 0.85;
  }
  100% {
    transform: translateX(100%);
    opacity: 1;
  }
`;

const showInfoMobile = keyframes`
  0% {
    transform: translate(100%, 70%);
    opacity: 0;
  }
  80% {
    transform: translate(100%, 95%);
    opacity: 0.85;
  }
  100% {
    transform: translate(100%, 100%);
    opacity: 1;
  }
`;

export const Info = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(100%);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px ${props => props.theme.border.stepperBorder};
  background-color: rgba(0, 103, 120, 1);
  width: 341px;
  height: 141px;
  padding: 16px 37px 17px 31px;
  color: ${props => props.theme.fontColors.white};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 2;
  z-index: 1;
  animation: ${showInfo} 1s linear forwards;
`;

export const Info1 = styled(Info)`
  display: flex;
  width: ${props => props.size+'px'} !important;
  @media only screen and (max-width: 320px) {
    padding: 16px 20px;
    right: ${props => (props.activeKey === 2 ? "94px" : "44px")};
    top: -92px;
    width: 281px;
    font-size: ${props => props.theme.fontSize.tertiary};
    z-index: 7;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    z-index: 7;
    padding: 16px 20px;
    right: ${props => (props.activeKey === 2 ? "110px" : "50px")};
    top: -92px;
    width: 337px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 376px) and (max-width: 425px) {
    z-index: 7;
    top: -92px;
    right: ${props => (props.activeKey === 2 ? "123px" : "57px")};
    width: 385px;
    padding: 16px 20px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 426px) and (max-width: 768px) {
    z-index: 7;
    top: -87px;
    right: ${props => (props.activeKey === 2 ? "258px" : "125px")};
    width: 719px;
    padding: 16px 20px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
`;

export const Info2 = styled(Info)`
  @media only screen and (max-width: 320px) {
    padding: 16px 20px;
    right: 126px;
    top: -99px;
    width: 248px;
    font-size: 12px;
    z-index: 4;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    z-index: 5;
    padding: 16px 20px;
    top: -99px;
    right: 142px;
    width: 290px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 376px) and (max-width: 425px) {
    z-index: 5;
    padding: 16px 20px;
    top: -99px;
    right: 142px;
    width: 329px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
  @media only screen and (min-width: 426px) and (max-width: 768px) {
    z-index: 5;
    top: -108px;
    right: 285px;
    width: 719px;
    padding: 16px 20px;
    transform: translate(100%, 0%);
    animation: ${showInfoMobile} 1s linear forwards;
  }
`;
export const Triangle = styled.div`
  position: absolute;
  top: 50%;
  left: -2px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 11px solid white;
  border-bottom: 8px solid transparent;
  transform: translateY(-50%);
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    left: ${props => (props.activeKey === 2 ? "26%" : "6%")}
    top: -3px;
    border-top: 6px solid transparent;
    border-left: 8px solid white;
    border-bottom: 6px solid transparent;
    transform: rotate(90deg);
  }
`;

export const InfoView = styled.div`
  display: ${props => props.flex ? 'flex' : 'unset'};
  width: inherit;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const InfoCheck = styled.div`
  align-items: center;
  margin-top: -10px;
`;

export const FlexEnd = styled.div`
  margin-bottom: 7px; 
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    align-self: flex-end;
  }        
`;

export const InfoName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 285px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 250px;  
  }        
`;

export const CloseTag = styled.div`
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: ${props => props.theme.fontSize.h5};
  @media only screen and (min-width: 769px) {
    display: none;
  }
`;

export const EllipsisText = styled.div`
  width:200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

